export const COMING_SOON_PATHS = [
  "/premium-cars",
  "/roadside-package",
  "/team",
  "/gallery",
];

export const isComingSoonPath = (pathname) =>
  COMING_SOON_PATHS.includes(pathname);
